import axios from 'axios';
import Bouncer from 'formbouncerjs/src/js/bouncer/bouncer';
import Forms from '../common/forms';

export default class Simulator {
    constructor() {
        this.section = document.querySelector('.block-simulator');
        this.form = document.querySelector('#formSimulator');

        // ------ Botoes de acao do valor por credito
        this.btnGetSimulatorByCreditValue = this.section.querySelector('#btnGetSimulatorByCreditValue');
        this.btnGetDataByCreditValueToSend = this.section.querySelector('#btnGetDataByCreditValueToSend');

        // ------ Botoes de acao do valor por parcela
        this.btnGetSimulatorByInstallmentValue = this.section.querySelector('#btnGetSimulatorByInstallmentValue');
        this.btnGetDataByInstallmentValueToSend = this.section.querySelector('#btnGetDataByInstallmentValueToSend');

        // ------ Botoes de acao do conforme producao
        this.btnGetSimulatorByProductionValue = this.section.querySelector('#btnGetSimulatorByProductionValue');
        this.btnGetDataByProductionToSend = this.section.querySelector('#btnGetDataByProductionToSend');

        // ------ Botoes de acao do envio dos dados
        this.btnSendContact = this.section.querySelector('#btnSendContact');
        this.btnGetPdf = this.section.querySelector('#btnGetPdf');
        this.btnReset = this.section.querySelector('#btnResetSimulator');

        // ------ Selects estado / cidade do conforme producao
        this.stateSelect = this.section.querySelector('#estado');
        this.citySelect = this.section.querySelector('#cidade');

        //------------------------
        this.currentFlowType = null; // CREDIT, INSTALLMENT, PRODUCTION
        this.lastSimulation = {}; // guarda dados retornados do simulador
        this.currentTabId = null;


        //------------------------
        this.init();
        this.rangeSlider();
        this.initTabs();

        new Forms();
    }

    init() {
        this.getRanges();

        this.btnGetSimulatorByCreditValue.addEventListener('click', async (e) => {
            e.preventDefault();
            this.btnGetSimulatorByCreditValue.ariaDisabled = 'true';
            this.btnGetSimulatorByCreditValue.classList.add('loading-white');
            const creditValue = this.section.querySelector('#range_valor_por_credito').value;
            const data = await this.getDataByCreditValue(creditValue);
        });

        this.btnGetSimulatorByInstallmentValue.addEventListener('click', async (e) => {
            e.preventDefault();
            this.btnGetSimulatorByInstallmentValue.ariaDisabled = 'true';
            this.btnGetSimulatorByInstallmentValue.classList.add('loading-white');
            const installmentValue = this.section.querySelector('#range_valor_por_parcela').value;
            const data = await this.getDataInstallmentValue(installmentValue);
        });

        this.btnGetSimulatorByProductionValue.addEventListener('click', async (e) => {
            e.preventDefault();

            // validação integrada com Forms.js
            if (!this.validateProductionValueInputs()) {
                return;
            }

            this.btnGetSimulatorByProductionValue.ariaDisabled = 'true';
            this.btnGetSimulatorByProductionValue.classList.add('loading-white');

            await this.getDataProductionValue();
        });

        // Change no estado → busca cidades
        this.stateSelect.addEventListener('change', (e) => {
            const stateId = e.target.value;
            if (stateId) {
                this.getCities(stateId);
            } else {
                this.citySelect.innerHTML = `<option value="">Selecione uma cidade</option>`;
                this.dataBlock.innerHTML = ``;
                this.dataBlock.classList.remove('active');
            }
        });

        new Bouncer(`#formSimulator`, {
            ...Forms.config(),
            messages: Forms.messages(),
        });

        this.form.addEventListener(
            'bouncerFormInvalid',
            (event) => {
                Forms.activeErros(this.form);

                // força erro visual no checkbox
                const accepted = this.form.querySelector('#accepted');
                if (accepted && !accepted.checked) {
                    accepted
                        .closest('.checkboxLine')
                        ?.querySelector('.erro-campo')
                        ?.classList.remove('hidden');
                }
            },
            false
        );

        this.form.addEventListener('submit', async (e) => {
            e.preventDefault();

            Forms.activeErros(this.form);

            if (this.form.querySelector('.error-field')) {
                return;
            }

            await this.sendContact();
        });



        if (this.btnReset) {
            this.btnReset.addEventListener('click', (e) => {
                e.preventDefault();
                this.resetSimulator();
            });
        }

        if (this.btnGetPdf) {
            this.btnGetPdf.addEventListener('click', (e) => {
                e.preventDefault();
                this.getPdf();
            });
        }

        const accepted = this.form.querySelector('#accepted');

        if (accepted) {
            accepted.addEventListener('change', () => {
                if (accepted.checked) {
                    accepted
                        .closest('.checkboxLine')
                        ?.querySelector('.erro-campo')
                        ?.classList.add('hidden');
                }
            });
        }

        this.bindBackButtons();

        const productionType = this.section.querySelector('#production_type');
        productionType?.addEventListener('change', () => this.updateProductionQuantityField());

    }

    isMilkProduction() {
        return this.section.querySelector('#production_type')?.value === 'LEITE';
    }

    updateProductionQuantityField() {
        const isMilk = this.isMilkProduction();
        const label = this.section.querySelector('#productionQuantityLabel');
        const error = this.section.querySelector('#productionQuantityError');
        const input = this.section.querySelector('#area_hectares');

        if (label) {
            const labelText = isMilk
                ? 'Produção de leite por vaca (mês)'
                : 'Quant. de hectares (ha) ou litros (l)';
            label.innerHTML = '<span>4</span>' + labelText;
        }

        if (error) {
            error.textContent = isMilk
                ? 'Informe a produção de leite por vaca ao mês'
                : 'Informe a quantidade de hectares (ha) ou litros (l)';
        }

        if (input) {
            input.setAttribute('aria-label', label?.textContent?.replace(/^4/, '') || 'Quantidade');
            input.classList.remove('error-field');
        }
    }

    initTabs() {
        const tabButtons = this.section.querySelectorAll('.tabsMenu [data-tab]');

        tabButtons.forEach((btn) => {
            btn.addEventListener('click', () => {
                const target = btn.dataset.tab;

                // --- Alterna botão ativo ---
                tabButtons.forEach((b) => b.classList.remove('active'));
                btn.classList.add('active');

                // --- Resetar simulador ---
                this.resetSimulator();

                // --- ATIVA TAB PELO MÉTODO CENTRAL ---
                this.setActiveTab(target, 'input');
            });
        });
    }

    setActiveTab(tabId, mode = 'input') {
        const tab = this.section.querySelector(`#${tabId}`);
        if (!tab) return;

        // Remove active de todas
        this.section.querySelectorAll('.tab')
            .forEach(t => t.classList.remove('active'));

        tab.classList.add('active');
        this.currentTabId = tabId;

        const blockInput = tab.querySelector('.blockInputData');
        const blockShow = tab.querySelector('.blockShowData');

        if (mode === 'show') {
            blockShow?.classList.add('active');
            blockInput?.classList.remove('active');
        } else {
            blockInput?.classList.add('active');
            blockShow?.classList.remove('active');
        }

        //SALVA ESTADO SOMENTE SE NÃO FOR CADASTRO
        if (tabId !== 'dados_cadastro') {
            this.lastTabId = tabId;
            this.lastTabMode = mode;
        }

    }

    bindBackButtons() {
        this.section.addEventListener('click', (e) => {
            const btn = e.target.closest('.btn-back-step');
            if (!btn) return;

            e.preventDefault();

            let tabId;
            let mode;

            if (btn.dataset.back === '__last') {
                tabId = this.lastTabId;
                mode = this.lastTabMode;
            } else {
                tabId = btn.dataset.back;
                mode = 'input';
            }

            if (!tabId) return;

            this.setActiveTab(tabId, mode);

            //NÃO limpar lastTabId aqui
            btn.classList.remove('loading-white');
            btn.ariaDisabled = 'false';
        });
    }

    //Carrega os dados do formulario se localStorage se tiver
    async loadCadastroFromStorage() {
        const saved = localStorage.getItem('cadastro_dados');
        if (!saved) return;

        console.log(saved);

        const { name, phone, city, email, uf } = JSON.parse(saved);

        const tabCadastro = this.section.querySelector('#dados_cadastro .blockInputData');
        if (!tabCadastro) return;

        // Preenche campos simples
        if (name) tabCadastro.querySelector('[name="name"]').value = name;
        if (email) tabCadastro.querySelector('[name="email"]').value = email;
        if (phone) tabCadastro.querySelector('[name="phone"]').value = phone;

        // ---- UF e Cidade (selects dinâmicos) ----

        const selectUf = tabCadastro.querySelector('[name="estado"]');
        const selectCity = tabCadastro.querySelector('[name="cidade"]');

        if (!selectUf || !selectCity) return;

        // -------------------------
        // UF → selecionar pelo texto
        // -------------------------
        const selectEstado = tabCadastro.querySelector('select[name="estado"]');
        const selectCidade = tabCadastro.querySelector('select[name="cidade"]');

        if (!selectEstado || !selectCidade || !uf) return;

        // Achar o option pelo texto interno (innerText)
        const optionUF = Array.from(selectEstado.options).find((opt) => opt.text.trim() === uf);

        if (!optionUF) return;

        // Selecionar o estado pelo VALUE correspondente
        selectEstado.value = optionUF.value;

        // Disparar evento change para acionar o método que popula as cidades
        selectEstado.dispatchEvent(new Event('change'));

        if (city) {
            const observer = new MutationObserver(() => {
                const optionCidade = Array.from(selectCidade.options).find((opt) => opt.text.trim() === city.trim());

                if (optionCidade) {
                    selectCidade.value = optionCidade.value;
                    selectCidade.dispatchEvent(new Event('change'));
                    observer.disconnect(); // Para de observar quando achou
                }
            });

            // Observar mudanças no select
            observer.observe(selectCidade, { childList: true });
        }
    }

    formatMoney(value) {
        return new Intl.NumberFormat('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value);
    }

    normalizeBRNumber(value) {
        if (!value) return null;

        return value
            .replace(/\./g, '') // remove TODOS os pontos
            .replace(',', '.'); // troca vírgula por ponto
    }

    rangeSlider() {
        const sliders = document.querySelectorAll("input[type='range']");
        const self = this;

        sliders.forEach((slider) => {
            slider.updateUI = () => {
                const val = ((slider.value - slider.min) / (slider.max - slider.min)) * 100;
                slider.style.setProperty('--progress', `${val}%`);

                const span = document.getElementById(`${slider.id}Value`);
                if (span) {
                    span.textContent = self.formatMoney(slider.value);
                }
            };

            slider.addEventListener('input', slider.updateUI);
            slider.updateUI();
        });
    }

    resetAllRangeSliders() {
        const sliders = this.section.querySelectorAll("input[type='range']");
        sliders.forEach((slider) => {
            slider.value = slider.min;
            slider.updateUI();
        });
    }

    setSliderRange({ sliderId, minId, maxId, valueId, min, max }) {
        const slider = this.section.querySelector(`#${sliderId}`);
        const minEl = this.section.querySelector(`#${minId}`);
        const maxEl = this.section.querySelector(`#${maxId}`);
        const valEl = this.section.querySelector(`#${valueId}`);

        if (!slider || !minEl || !maxEl || !valEl) {
            console.warn('setSliderRange: elemento não encontrado', {
                sliderId,
                minId,
                maxId,
                valueId,
            });
            return;
        }

        slider.min = min;
        slider.max = max;
        slider.value = min;

        minEl.textContent = this.formatMoney(min);
        maxEl.textContent = this.formatMoney(max);
        valEl.textContent = this.formatMoney(min);
    }

    formatNearestValueResponse(data) {
        return {
            ...data,
            original_value: this.formatMoney(data.original_value),
            nearest_value: this.formatMoney(data.nearest_value),

            available_installments: data.available_installments.map((item) => ({
                ...item,
                value: this.formatMoney(item.value),
                total_cost: this.formatMoney(item.total_cost),
            })),
        };
    }

    activeInfosForm() {
        if (this.currentTabId !== 'dados_cadastro') {
            this.lastTabId = this.currentTabId;

            const currentTab = this.section.querySelector(`#${this.currentTabId}`);
            this.lastTabMode = currentTab?.querySelector('.blockShowData.active')
                ? 'show'
                : 'input';
        }

        this.setActiveTab('dados_cadastro', 'input');
    }

    resetSimulator() {
        //RESET TOTAL DE ESTADO
        this.lastTabId = null;
        this.lastTabMode = 'input';
        this.currentTabId = null;

        // reset UI
        this.section.querySelectorAll('.blockShowData')
            .forEach(el => el.classList.remove('active'));

        this.section.querySelectorAll('.blockInputData')
            .forEach(el => el.classList.add('active'));

        this.section.querySelectorAll('.tab')
            .forEach(tab => tab.classList.remove('active'));

        // ativa aba do botão selecionado
        const activeBtn = this.section.querySelector('.tabsMenu [data-tab].active');
        if (activeBtn) {
            this.setActiveTab(activeBtn.dataset.tab, 'input');
        }

        this.resetAllRangeSliders();

        // reset erros
        this.section.querySelectorAll('.erro-campo')
            .forEach(err => err.classList.add('hidden'));

        // reset tabelas
        this.section.querySelectorAll('table tbody')
            .forEach(tb => (tb.innerHTML = ''));

        // this.section.scrollIntoView({ behavior: 'smooth' });
    }

    async getCities(stateId) {
        // ------ Mesmo método é utilizado em dealer-find ------
        try {
            this.citySelect.disabled = true;

            this.citySelect.innerHTML = `<option value="">Carregando...</option>`;

            const response = await axios.get(`/dealers/cidades/${stateId}`);
            const cidades = response.data;

            this.citySelect.innerHTML = `<option value="" selected disabled>Selecione uma cidade</option>`;

            Object.entries(cidades).forEach(([nome, id]) => {
                const opt = document.createElement('option');
                opt.value = id;
                opt.textContent = nome;
                this.citySelect.appendChild(opt);
            });

            this.citySelect.disabled = false;
        } catch (error) {
            console.error('Erro ao carregar cidades:', error);
            this.citySelect.innerHTML = `<option value="">Erro ao carregar</option>`;
        }
    }

    async getRanges() {
        const loadingTab = this.section.querySelector('#loading');
        const valorCreditoTab = this.section.querySelector('#valor_credito');

        // Mostra loading imediatamente
        loadingTab.classList.add('active');
        valorCreditoTab.classList.remove('active');
        this.section.querySelector('.tabsMenu').classList.add('pointer-events-none');

        try {
            // --- RODAR TUDO EM PARALELO ---
            const [creditRes, installmentRes, productionRes] = await Promise.all([
                axios.get('/api/simulator/credit/ranges'),
                axios.get('/api/simulator/installment/ranges'),
                axios.get('/api/simulator/production/types'),
            ]);

            const credit = creditRes.data.data;
            const inst = installmentRes.data.data;
            const prod = productionRes.data.data;

            // --- RANGES CRÉDITO ---
            this.setSliderRange({
                sliderId: 'range_valor_por_credito',
                minId: 'range_valor_por_creditoMin',
                maxId: 'range_valor_por_creditoMax',
                valueId: 'range_valor_por_creditoValue',
                min: credit.min_value,
                max: credit.max_value,
            });

            // --- RANGES PARCELA ---
            this.setSliderRange({
                sliderId: 'range_valor_por_parcela',
                minId: 'range_valor_por_parcelaMin',
                maxId: 'range_valor_por_parcelaMax',
                valueId: 'range_valor_por_parcelaValue',
                min: inst.min_installment_value,
                max: inst.max_installment_value,
            });

            // --- PRODUÇÕES ---
            const selectProd = this.section.querySelector('#production_type');
            const frag = document.createDocumentFragment();

            Object.entries(prod).forEach(([key, item]) => {
                const option = document.createElement('option');
                option.value = key;
                option.textContent = item.name_pt;
                option.dataset.unit = item.unit ?? '';
                option.dataset.weight = item.unit_weight ?? '';
                frag.appendChild(option);
            });

            // Mantém o fluxo disponível caso a listagem da API ainda não inclua LEITE.
            if (!Object.prototype.hasOwnProperty.call(prod, 'LEITE')) {
                const milkOption = document.createElement('option');
                milkOption.value = 'LEITE';
                milkOption.textContent = 'Leite';
                milkOption.dataset.unit = 'Litros';
                frag.appendChild(milkOption);
            }

            selectProd.appendChild(frag);

            // --- TABS ---
            loadingTab.classList.remove('active');
            valorCreditoTab.classList.add('active');
            this.section.querySelector('.tabsMenu').classList.remove('pointer-events-none');
        } catch (error) {
            console.error('Erro ao buscar ranges:', error);
            // opcional: mostrar UI de erro
        }
    }

    // ------- VALOR DE CREDITO -------
    async getDataByCreditValue(creditValue) {
        try {
            const valueToSend = creditValue.replace(',', '.');
            const response = await axios.post('/api/simulator/credit/nearest-value', {
                selected_value: valueToSend,
            });

            const data = response.data.data;
            // console.log('Retorno', data);

            // Salva dados principais
            this.currentFlowType = 'CREDIT';
            this.lastCreditNearestResponse = data; // guardamos tudo
            this.currentCreditCode = data.credit_code;

            // Valores padrão iniciais (primeira parcela)
            this.lastSimulation = {
                credit_value: data.nearest_value,
                installment_quantity: data.available_installments[0].quantity,
                installment_value: data.available_installments[0].value,
            };

            // console.log('Last Simulation', this.lastSimulation)

            // Atualiza interface
            this.section.querySelector('#creditoValue').textContent = this.formatMoney(data.nearest_value);

            const tbody = this.section.querySelector('#tabelaParcelas tbody');
            tbody.innerHTML = '';

            const installmentsSorted = [...data.available_installments].sort((a, b) => a.quantity - b.quantity);

            installmentsSorted.forEach((item, index) => {
                const tr = document.createElement('tr');
                tr.classList.add('border-b', 'border-light');

                tr.innerHTML = `
                    <td class="px-6 py-3 text-center">
                        <label class="radio-option radio-option--black">
                            <input type="radio" 
                                class="radio-custom installment-option"
                                name="selected_installment" 
                                data-quantity="${item.quantity}"
                                data-value="${item.value}"
                                value="${item.installment_id}" 
                                ${index === 0 ? 'checked' : ''}>
                        </label>
                    </td>
                    <td class="pr-10 py-3 text-center">${item.quantity}x</td>
                    <td class="pr-10 py-3 text-center">R$ ${this.formatMoney(item.value)}</td>
                `;

                tbody.appendChild(tr);
            });

            this.section.querySelector('#valor_credito .blockInputData').classList.remove('active');
            this.section.querySelector('#valor_credito .blockShowData').classList.add('active');

            this.btnGetSimulatorByCreditValue.ariaDisabled = 'false';
            this.btnGetSimulatorByCreditValue.classList.remove('loading-white');

            this.btnGetDataByCreditValueToSend.addEventListener('click', (e) => {
                e.preventDefault();
                this.getDataByCreditValueToSend();
            });
        } catch (error) {
            console.error('Erro ao buscar nearest value:', error);

            this.btnGetSimulatorByCreditValue.ariaDisabled = 'false';
            this.btnGetSimulatorByCreditValue.classList.remove('loading-white');

            this.btnGetDataByCreditValueToSend.ariaDisabled = 'false';
            this.btnGetDataByCreditValueToSend.classList.remove('loading-white');
        }

        // this.section.scrollIntoView({ behavior: 'smooth' });
    }

    async getDataByCreditValueToSend() {
        try {
            this.btnGetDataByCreditValueToSend.ariaDisabled = 'true';
            this.btnGetDataByCreditValueToSend.classList.add('loading-white');

            // Recupera credit_code salvo no método anterior
            const creditCode = this.currentCreditCode;

            if (!creditCode) {
                console.error('Erro: credit_code não encontrado.');
                return;
            }

            // Pega o installment selecionado pelo radio
            const selected = this.section.querySelector('.installment-option:checked');

            if (!selected) {
                console.error('Nenhuma parcela selecionada.');
                return;
            }

            const installmentQuantity = selected.dataset.quantity;

            const payload = {
                credit_code: creditCode,
                installment: installmentQuantity,
            };

            const response = await axios.post('/api/simulator/credit/simulation', payload);
            const data = response.data.data;

            // console.log('Retorno simulacao', data)

            //Salva no estado
            this.lastSimulation = {
                credit_value: data.credit_value,
                credit_code: data.credit_code,
                monthly_installment: data.monthly_installment,
                annual_total: data.annual_total,
                installment_quantity: selected.dataset.quantity,
                installment_value: data.monthly_installment,
            };

            this.btnGetDataByCreditValueToSend.ariaDisabled = 'false';
            this.btnGetDataByCreditValueToSend.classList.remove('loading-white');
            this.activeInfosForm();
        } catch (err) {
            console.error('Erro ao enviar simulação final:', err);
        }

        // this.section.scrollIntoView({ behavior: 'smooth' });
    }

    // ------- VALOR POR PARCELA -------
    async getDataInstallmentValue(installmentValue) {
        try {
            const valueToSend = installmentValue.replace(',', '.');
            const response = await axios.post('/api/simulator/installment/credit-limit', {
                desired_installment_value: valueToSend,
            });

            const data = response.data.data;
            // console.log('Retorno', data);

            // Salva dados principais
            this.currentFlowType = 'INSTALLMENT';
            this.lastInstallmentResponse = data; // guardamos tudo
            this.currentCreditCode = data.closest_installment_options[0].credit_code;

            this.lastSimulation = {
                credit_value: data.closest_installment_options[0].credit_value,
                installment_quantity: data.closest_installment_options[0].quantity,
                installment_value: data.closest_installment_options[0].value,
            };

            // console.log('Last Simulation', this.lastSimulation)

            // Seleciona o tbody da tabela
            const tbody = this.section.querySelector('#tabelaParcelas2 tbody');
            tbody.innerHTML = ''; // limpa tabela

            // Ordena pelo número de parcelas (quantity)
            const installmentsSorted = [...data.closest_installment_options].sort((a, b) => a.quantity - b.quantity);

            // Loop das parcelas dentro do próprio método
            installmentsSorted.forEach((item, index) => {
                const tr = document.createElement('tr');
                tr.classList.add('border-b', 'border-light');

                tr.innerHTML = `
                    <td class="px-6 py-3 text-center">
                        <label class="radio-option radio-option--black">
                            <input type="radio" 
                                class="radio-custom installment-option-par"
                                name="selected_installment"
                                data-cod="${item.credit_code}"
                                data-quantity="${item.quantity}"
                                data-value="${item.value}"
                                data-total="${item.credit_value}"
                                value="${item.installment_id}" 
                                ${index === 0 ? 'checked' : ''}>
                        </label>
                    </td>
                    <td class="pr-10 py-3 text-center">${item.quantity}x</td>
                    <td class="pr-10 py-3 text-center">R$ ${this.formatMoney(item.value)}</td>
                    <td class="pr-10 py-3 text-center">R$ ${this.formatMoney(item.credit_value)}</td>
                `;

                tbody.appendChild(tr);
            });

            // Troca de telas
            this.section.querySelector('#valor_parcela .blockInputData').classList.remove('active');
            this.section.querySelector('#valor_parcela .blockShowData').classList.add('active');

            // Remove loading-white do botão
            this.btnGetSimulatorByInstallmentValue.ariaDisabled = 'false';
            this.btnGetSimulatorByInstallmentValue.classList.remove('loading-white');

            this.btnGetDataByInstallmentValueToSend.addEventListener('click', (e) => {
                e.preventDefault();
                this.getDataByInstallmentValueToSend();
            });
        } catch (error) {
            console.error('Erro ao buscar nearest value:', error);

            // Em caso de erro, destrava botão
            this.btnGetSimulatorByCreditValue.ariaDisabled = 'false';
            this.btnGetSimulatorByCreditValue.classList.remove('loading-white');

            this.btnGetDataByInstallmentValueToSend.ariaDisabled = 'false';
            this.btnGetDataByInstallmentValueToSend.classList.remove('loading-white');
        }

        // this.section.scrollIntoView({ behavior: 'smooth' });
    }

    async getDataByInstallmentValueToSend() {
        try {
            this.btnGetDataByInstallmentValueToSend.ariaDisabled = 'true';
            this.btnGetDataByInstallmentValueToSend.classList.add('loading-white');

            // Recupera credit_code salvo no método anterior
            const creditCode = this.currentCreditCode;

            if (!creditCode) {
                console.error('Erro: credit_code não encontrado.');
                return;
            }

            // Pega o installment selecionado pelo radio
            const selected = this.section.querySelector('.installment-option-par:checked');

            if (!selected) {
                console.error('Nenhuma parcela selecionada.');
                return;
            }

            const installmentQuantity = selected.dataset.quantity;

            const payload = {
                credit_code: creditCode,
                installment: installmentQuantity,
            };

            const response = await axios.post('/api/simulator/installment/simulation', payload);
            const data = response.data.data;

            // console.log('Retorno simulacao', data)

            //Salva no estado
            this.lastSimulation = {
                credit_value: data.credit_value,
                credit_code: data.credit_code,
                monthly_installment: data.monthly_installment,
                annual_total: data.annual_total,
                installment_quantity: selected.dataset.quantity,
                installment_value: data.monthly_installment,
            };

            this.btnGetDataByInstallmentValueToSend.ariaDisabled = 'false';
            this.btnGetDataByInstallmentValueToSend.classList.remove('loading-white');
            this.activeInfosForm();
        } catch (err) {
            console.error('Erro ao enviar simulação final:', err);
        }

        // this.section.scrollIntoView({ behavior: 'smooth' });
    }

    // ------- CONFORME PRODUCAO -------
    validateProductionValueInputs() {
        const fields = [
            this.section.querySelector('#credit_value'),
            this.section.querySelector('#production_type'),
            this.section.querySelector('#price_per_unit'),
            this.section.querySelector('#area_hectares'),
        ];

        let isValid = true;

        fields.forEach((field) => {
            if (!field.value.trim()) {
                field.classList.add('error-field');
                isValid = false;
            } else {
                field.classList.remove('error-field');
            }

            // remove erro ao digitar
            field.addEventListener('input', () => {
                if (field.value.trim()) {
                    field.classList.remove('error-field');
                }
            });
        });

        const quantityField = this.section.querySelector('#area_hectares');
        const quantity = Number(this.normalizeBRNumber(quantityField.value));
        if (this.isMilkProduction() && (!Number.isFinite(quantity) || quantity <= 0)) {
            quantityField.classList.add('error-field');
            isValid = false;
            Forms.activeErros(this.section);
        }

        // ativa os erros usando sua função global
        Forms.activeErros(this.section);

        return isValid;
    }

    async getDataProductionValue() {
        try {
            // --------- CAMPOS DO FORM ---------
            const creditValue = this.section.querySelector('#credit_value')?.value;
            const productionType = this.section.querySelector('#production_type')?.value;
            const pricePerUnit = this.section.querySelector('#price_per_unit')?.value;
            const productionQuantity = this.section.querySelector('#area_hectares')?.value;

            if (!creditValue || !productionType || !pricePerUnit || !productionQuantity) {
                console.error('Campos obrigatórios não preenchidos.');
                return;
            }

            // Normaliza valores numéricos
            const normalizedQuantity = this.normalizeBRNumber(productionQuantity);
            const isMilk = productionType === 'LEITE';
            const payload = {
                credit_value: this.normalizeBRNumber(creditValue),
                production_type: productionType,
                price_per_unit: this.normalizeBRNumber(pricePerUnit),
            };

            payload[isMilk ? 'milk_liters_per_cow_monthly' : 'area_hectares'] = normalizedQuantity;

            const response = await axios.post('/api/simulator/production/simulation', payload);
            const data = response.data.data;
            // console.log('Retorno', data);

            this.currentFlowType = 'PRODUCTION';
            //Salva no estado
            this.lastSimulation = {
                credit_value: data.credit_value,
                credit_code: data.credit_code,
                monthly_installment: data.monthly_installment,
                annual_total: data.annual_total,
                installment_quantity: data.installment_quantity,
                installment_value: data.monthly_installment,
                price_per_unit: data.production_calculations.price_per_unit,
                production_type: productionType,
                area_hectares: isMilk ? null : data.production_calculations.area_hectares,
                milk_liters_per_cow_monthly: isMilk ? data.production_calculations.milk_liters_per_cow_monthly : null,
                cows_needed: isMilk ? data.production_calculations.cows_needed : null,
            };

            const prod = data.production_calculations;
            const productionName = prod.production_type || '';
            // pega o option selecionado do select já existente
            const select = this.section.querySelector('#production_type');
            const selectedOption = select.options[select.selectedIndex];

            // se existir data-unit usa, senão fallback para "un"
            const unit = selectedOption?.dataset?.unit || 'un';

            const monthly = prod.monthly_units_needed; // por mês
            const annual = prod.annual_units_needed; // por ano
            const annualPerHa = isMilk ? null : annual / prod.area_hectares; // ano/ha

            this.section.querySelector('#productionLabel1').textContent = isMilk
                ? 'Quantidade de vacas no ano'
                : `Quantidade de ${productionName.toLowerCase()} mês`;
            this.section.querySelector('#productionLabel2').textContent = isMilk
                ? 'Quantidade de litros por mês'
                : `Quantidade de ${productionName.toLowerCase()} ano`;
            this.section.querySelector('#productionLabel3').textContent = isMilk
                ? 'Quantidade de litros por ano'
                : `Quantidade de ${productionName.toLowerCase()} ano/ha`;

            // Monthly
            this.section.querySelector('#productionData1 .number').textContent = isMilk
                ? prod.cows_needed.toLocaleString('pt-BR')
                : monthly.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
            this.section.querySelector('#productionData1 .unit').textContent = isMilk ? 'vacas' : unit;

            // Annual
            this.section.querySelector('#productionData2 .number').textContent = (isMilk ? monthly : annual).toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
            });
            this.section.querySelector('#productionData2 .unit').textContent = isMilk ? 'litros' : unit;

            // Annual por hectare
            this.section.querySelector('#productionData3 .number').textContent = (isMilk ? annual : annualPerHa).toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
            });
            this.section.querySelector('#productionData3 .unit').textContent = isMilk ? 'litros' : unit + '/ha';

            // --------- TROCA DE TELA ---------
            this.section.querySelector('#conforme_producao .blockInputData').classList.remove('active');
            this.section.querySelector('#conforme_producao .blockShowData').classList.add('active');

            // --------- REMOVE LOADING ---------
            this.btnGetSimulatorByProductionValue.ariaDisabled = 'false';
            this.btnGetSimulatorByProductionValue.classList.remove('loading-white');

            this.btnGetDataByProductionToSend.addEventListener('click', (e) => {
                e.preventDefault();
                this.activeInfosForm();
            });
        } catch (error) {
            console.error('Erro ao simular produção:', error);

            this.btnGetSimulatorByProductionValue.ariaDisabled = 'false';
            this.btnGetSimulatorByProductionValue.classList.remove('loading-white');
        }

        // this.section.scrollIntoView({ behavior: 'smooth' });
    }

    // ------- POST DOS DADOS -------
    async sendContact() {
        console.log('🔥 sendContact INICIADO');
        try {
            console.log('🔥 sendContact EXECUTANDO');
            this.btnSendContact.classList.add('loading-white');
            this.btnSendContact.ariaDisabled = 'true';

            const name = this.section.querySelector('#name')?.value?.trim();
            const phone = this.section.querySelector('#phone')?.value?.trim();
            const email = this.section.querySelector('#email')?.value?.trim();

            const cidade = this.section.querySelector('#cidade')?.selectedOptions[0]?.textContent;
            const uf = this.section.querySelector('#estado')?.selectedOptions[0]?.textContent;

            if (!name || !email || !phone || !cidade || !uf) {
                console.error('Campos obrigatórios não preenchidos.');
                this.btnSendContact.classList.remove('loading-white');
                this.btnSendContact.ariaDisabled = 'false';
                return;
            }

            const payload = {
                flow_type: this.currentFlowType,
                credit_value: this.lastSimulation.credit_value || null,
                installment_quantity: +this.lastSimulation.installment_quantity || null,
                installment_value: this.lastSimulation.installment_value || null,
                annual_total: this.lastSimulation.annual_total || null,
                name,
                phone,
                city: `${cidade}/${uf}`,
                email,
                price_per_unit: this.lastSimulation.price_per_unit,
                area_hectares: this.lastSimulation.area_hectares,
            };

            if (this.lastSimulation.production_type === 'LEITE') {
                payload.milk_liters_per_cow_monthly = this.lastSimulation.milk_liters_per_cow_monthly;
                payload.cows_needed = this.lastSimulation.cows_needed;
                delete payload.area_hectares;
            }

            if (this.lastSimulation.production_type) {
                payload.production_type = this.lastSimulation.production_type;
            }

            // console.log("Payload contato:", payload);

            const response = await axios.post('/api/simulator/contact', payload);
            // console.log("Contato enviado:", response.data);

            // salvar dados no storage
            localStorage.setItem(
                'cadastro_dados',
                JSON.stringify({
                    name,
                    phone,
                    city: `${cidade}`,
                    email,
                    uf,
                })
            );

            // --------- TROCA DE TELA ---------
            this.section.querySelector('#dados_cadastro .blockInputData').classList.remove('active');
            this.section.querySelector('#dados_cadastro .blockShowData').classList.add('active');
        } catch (error) {
            console.error('Erro ao enviar contato:', error);
        }

        this.btnSendContact.classList.remove('loading-white');
        this.btnSendContact.ariaDisabled = 'false';
    }

    async getPdf() {
        try {
            this.btnGetPdf.classList.add('loading-white');
            this.btnGetPdf.ariaDisabled = 'true';

            const name = this.section.querySelector('#name')?.value?.trim();
            const phone = this.section.querySelector('#phone')?.value?.trim();
            const email = this.section.querySelector('#email')?.value?.trim();

            const cidade = this.section.querySelector('#cidade')?.selectedOptions[0]?.textContent;
            const uf = this.section.querySelector('#estado')?.selectedOptions[0]?.textContent;

            let payload = {
                flow_type: this.currentFlowType,
                credit_value: this.lastSimulation.credit_value || null,
                installment_quantity: +this.lastSimulation.installment_quantity || null,
                installment_value: this.lastSimulation.installment_value || null,
                annual_total: this.lastSimulation.annual_total || null,
                name,
                phone,
                city: `${cidade}/${uf}`,
                email,
            };

            if (this.currentFlowType === 'PRODUCTION') {
                payload = {
                    ...payload, // mantém os dados anteriores
                    production_type: this.lastSimulation.production_type,
                    prod_name: this.lastSimulation.production_type || '',
                    prod_unit: this.section.querySelector('#productionData1 .unit')?.textContent || '',
                    prod_value1: this.lastSimulation.production_type === 'LEITE'
                        ? this.section.querySelector('#productionData2 .number')?.textContent || ''
                        : this.section.querySelector('#productionData1 .number')?.textContent || '',
                    prod_value2: this.lastSimulation.production_type === 'LEITE'
                        ? this.section.querySelector('#productionData3 .number')?.textContent || ''
                        : this.section.querySelector('#productionData2 .number')?.textContent || '',
                    prod_value3: this.section.querySelector('#productionData3 .number')?.textContent || '',
                    area_hectares: this.lastSimulation.area_hectares,
                    milk_liters_per_cow_monthly: this.lastSimulation.milk_liters_per_cow_monthly,
                    cows_needed: this.lastSimulation.cows_needed,
                };
            }

            // console.log("Payload pdf:", payload);

            const response = await axios.post('/api/simulator/pdf', payload, {
                // responseType: 'blob'
            });

            // console.log("Resposta PDF:", response);
            // console.log("Resposta PDF Data:", response.data);

            const link = document.createElement('a');
            link.href = 'data:application/pdf;base64,' + response.data.pdf;
            link.download = 'simulacao.pdf';
            link.click();
        } catch (error) {
            console.error('Erro ao gerar pdf:', error);
        }

        this.btnGetPdf.classList.remove('loading-white');
        this.btnGetPdf.ariaDisabled = 'false';
    }
}

if (document.querySelector('.block-simulator')) {
    new Simulator();
}
